// extracted by mini-css-extract-plugin
module.exports = {"check-animation":"CheckAnimation_check-animation__a_YPe","check-path-animation":"CheckAnimation_check-path-animation__SJSzH"};